import React, { useMemo, useCallback } from 'react';
import { BaseFilter, BaseFilterState, FilterConfig } from '../../../shared/ui';
import { PaymentV2Filters, paymentsV2Api, UserV2 } from '../../../api/paymentsV2Api';
import { User } from '../../../api/usersApi';
import './ManagedPaymentsFilter.css';

interface ManagedPaymentsFilterProps {
  filters: PaymentV2Filters;
  onFiltersChange: (filters: PaymentV2Filters) => void;
  loading?: boolean;
  className?: string;
}

const ManagedPaymentsFilter: React.FC<ManagedPaymentsFilterProps> = ({ 
  filters, 
  onFiltersChange, 
  loading = false,
  className = ''
}) => {
  // Конфигурация фильтров для платежей объектов - период и пользователь
  const filterConfig: FilterConfig[] = useMemo(() => [
    { type: 'period', label: 'Период', enabled: true },
    { type: 'user', label: 'Сотрудник', enabled: true }
  ], []);

  // Преобразуем локальное состояние в базовое
  const baseFilters: BaseFilterState = useMemo(() => ({
    startDate: filters.startDate,
    endDate: filters.endDate,
    userId: filters.userId
  }), [filters.startDate, filters.endDate, filters.userId]);

  // Обработчик изменений фильтров
  const handleBaseFiltersChange = useCallback((newFilters: BaseFilterState) => {
    // Преобразуем базовые фильтры обратно в локальное состояние
    const updatedFilters: PaymentV2Filters = {
      startDate: newFilters.startDate,
      endDate: newFilters.endDate,
      userId: newFilters.userId
    };
    
    onFiltersChange(updatedFilters);
  }, [onFiltersChange]);

  // Кастомная функция для загрузки доступных пользователей
  const loadAccessibleUsers = useCallback(async (): Promise<User[]> => {
    const accessibleUsers = await paymentsV2Api.getAccessibleUsers();
    // Преобразуем UserV2 в User для BaseFilter
    return accessibleUsers.map((u: UserV2): User => ({
      id: u.id,
      name: u.name,
      closed: u.closed,
    }));
  }, []);

  return (
    <div className={`managed-payments-filter ${className}`}>
      <BaseFilter
        filters={baseFilters}
        onFiltersChange={handleBaseFiltersChange}
        filterConfig={filterConfig}
        showLoading={loading}
        customUsersLoader={loadAccessibleUsers}
      />
    </div>
  );
};

export default ManagedPaymentsFilter;

